// secondary actions
export const SACT = {
  VIEW_DETAILS: {
    id: 0,
    name: 'VIEW_DETAILS'
  },
  EDIT_SELECTED: {
    id: 1,
    name: 'EDIT_SELECTED'
  },
  VIEW_SELECTED: {
    id: 2,
    name: 'VIEW_SELECTED'
  },
  BULK_EDIT: {
    id: 4,
    name: 'BULK_EDIT'
  },
};

// list actions
export const LACT = {
  ADD_TO_LIST: {
    id: 0,
    name: 'ADD_TO_LIST'
  },
  REMOVE_FROM_LIST: {
    id: 1,
    name: 'REMOVE_FROM_LIST'
  },
};
